import React, { useState } from "react";

import PublicTable from "components/PublicTable";
import PublicFilter from "components/PublicFilter";

const DocumentsSearch = (params) => {
  const notificationReference = React.useRef(null);

  const [isBusy, setIsBusy] = useState(false);
  const [filterData, setFilterData] = useState({
    issuerId: params?.match?.params?.issuer
      ? parseInt(params?.match?.params?.issuer)
      : null,
  });

  const [documentsData, setDocumentsData] = useState({
    data: [],
    totalSize: 0,
  });

  return (
    <main className="main text-center">
      <PublicFilter
        {...params}
        data={filterData}
        setData={setFilterData}
        setDocumentsData={setDocumentsData}
        isBusy={isBusy}
        setIsBusy={setIsBusy}
        alertRef={notificationReference}
      />

      <PublicTable
        filterData={filterData}
        setFilterData={setFilterData}
        documentsData={documentsData}
      />
    </main>
  );
};

export default DocumentsSearch;
